import { FC, PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { Stack } from "../../layout";
import { Body, Semibold } from "../../typography";

/** The `NoResultsOnFilter` component properties. */
export interface NoResultsOnFilterProps {}

/**
 * The `NoResultsOnFilter` component.
 */
export const NoResultsOnFilter: FC<PropsWithChildren<NoResultsOnFilterProps>> = () => {
  return (
    <Stack spacing="mini" className={classNames(styles.NoResultsOnFilter, "no-results")}>
      <Body textAlign="center" size="medium"><Semibold>No Results Found</Semibold></Body>
    </Stack>
  );
};
